export const customerDetailsActivityTabs = {
    activityLog: 'activityLog',
    reservation: 'reservation',
    reservationBooking: 'reservationBooking',
    reservationNoShow: 'reservationNoShow',
    competitions: 'competitions'
};
